// x-ref: https://github.com/Faire/backend/blob/2cbb7030eb8462e7b0cf239c541a9adebeb3c9f2/core/core-logging/src/main/kotlin/com/faire/core/logging/LogMetadataKeys.kt#L3
export enum LogMetadataKey {
  IP_ADDRESS = "ipAddress",
  REFERER = "referer",
  TIMESTAMP = "timestamp",

  // Custom standard attributes:
  REQUEST_ID = "http.request_id",
  REQUEST_USER_AGENT = "http.useragent",
  REQUEST_PATHNAME = "http.request.pathname",
  REQUEST_CONTENT_TYPE = "http.request.content_type",
  REQUEST_FORWARDED_LOCALE_SUBFOLDER = "http.request.forwarded_locale_subfolder",
  RESPONSE_DATA = "http.response.data",
  REQUEST_DATA = "http.request.data",
  HTTP_ROUTE = "http.route",

  // Session tags:
  SESSION_TOKEN = "session.token",
  SESSION_WRITE_MODE = "session.write_mode",
  SESSION_AUTH_VERSION = "session.auth.version",
  SESSION_USER_TOKEN = "session.user.token",
  SESSION_BRAND_TOKEN = "session.brand.token",
  SESSION_RETAILER_TOKEN = "session.retailer.token",
  SESSION_IMPERSONATOR_TOKEN = "session.impersonator.token",
  SESSION_SERVICE_ACCOUNT_NAME = "session.service_account.name",

  // Client-related tags:
  CLIENT_RELEASE = "clientRelease",

  // Endpoint annotations:
  FAIRE_PILLAR = "faire.pillar",
  FAIRE_POD = "faire.pod",
  FAIRE_PRODUCT_AREA = "faire.product_area",
  FAIRE_ONCALL = "faire.oncall",
  FAIRE_PRIORITY = "faire.priority",

  CLOUDFLARE_RAY_ID = "cloudflare.ray_id",
  CLOUDFLARE_EDGE_RAY_ID = "cloudflare.edge_ray_id",
  JA3_FINGERPRINT = "cloudflare.security.ja3_fingerprint",
  JA4_FINGERPRINT = "cloudflare.security.ja4_fingerprint",
  BOT_PROTECTION_VERIFIED_BOT = "cloudflare.security.bot_protection.verified_bot",
  BOT_PROTECTION_BOT_SCORE = "cloudflare.security.bot_protection.bot_score",
  BOT_PROTECTION_BOT_SCORE_STRING = "cloudflare.security.bot_protection.bot_score_string",
  BOT_PROTECTION_BOT_SCORE_CATEGORY = "cloudflare.security.bot_protection.bot_score_category",
  CLOUDFLARE_JS_DETECTION_PASSED = "cloudflare.security.js_detection_passed",
  SHOULD_FLAG_FOR_MFA = "cloudflare.security.should_flag_for_mfa",
  CLOUDFLARE_THREAT_SCORE = "cloudflare.security.threat_score",

  E2E_TEST_TOKEN = "faire.e2e.e2e_test_token",

  HACKERONE_USERNAME = "hackerone.username",

  ROOT_OPERATION_ID_KEY = "rop",
  ROOT_OPERATION_TYPE_KEY = "ropt",
  PARENT_OPERATION_ID_KEY = "pop",
  PARENT_OPERATION_TYPE_KEY = "popt",
  OPERATION_ID_KEY = "op",
  OPERATION_TYPE_KEY = "opt",
}
